import styled from 'styled-components';

/**
 * O card vive dentro do BasicBox com a prop gradient, que ja define o fundo
 * e a cor do texto como branco. Aqui nao se define cor de marca nova: so
 * transparencias sobre o branco herdado, para nao fugir da paleta da pagina.
 *
 * A altura util e curta (cerca de 55px no desktop, com o padding do BasicBox),
 * entao os tamanhos abaixo sao propositalmente pequenos.
 */
export const AvisosWidgetStyle = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-width: 0;

  .avisos-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .avisos-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    opacity: 0.85;
  }

  .avisos-indicadores {
    display: flex;
    gap: 5px;

    button {
      width: 6px;
      height: 6px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.4);
      cursor: pointer;
      transition: background 0.2s ease;

      &.ativo {
        background: rgba(255, 255, 255, 1);
      }

      &:hover {
        background: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .avisos-corpo {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    color: inherit;
    text-decoration: none;

    img {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
    }

    &:hover .avisos-titulo {
      text-decoration: underline;
    }

    &.institucional {
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
    }
  }

  .avisos-titulo {
    display: block;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    margin: 0;
  }

  .avisos-texto {
    display: block;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.3;
    opacity: 0.9;
    color: inherit;
  }

  a.avisos-texto:hover {
    text-decoration: underline;
  }

  @media screen and (max-width: 768px) {
    .avisos-titulo {
      font-size: 14px;
    }
    .avisos-texto {
      font-size: 13px;
    }
  }
`
